export const PRELOADER = {
    SHOW: 'PRELOADER.SHOW',
    HIDE: 'PRELOADER.HIDE',
};

export type AppStatePreloader = {
    isShow: boolean;
    isPerformingRequest: boolean;
};

export interface IPreloaderShowAction {
    type: typeof PRELOADER.SHOW;
}

export interface IPreloaderHideAction {
    type: typeof PRELOADER.HIDE;
}

export type PreloaderActionTypes = IPreloaderShowAction | IPreloaderHideAction;
